import React from "react";

const NewHeroSection = () => {
  return (
    <div>
      {/* Upper Section */}
      <div style={{ background: "linear-gradient(to bottom, #FFFFFF, #E9E8E3)" }}>
        {/* Text Content */}
        <div className="px-4  max-w-5xl mx-auto w-full pt-10 sm:pt-14 lg:pt-20 pb-6  text-center">
          <h1
            className="mb-3 sm:mb-4 text-xl sm:text-2xl lg:text-[42px]"
            style={{ fontSize: "42px", fontWeight: 600, lineHeight: 1.2, color: "#181818" }}
          >
            Everything you need branded.{" "}
            <span
              style={{
                background: "linear-gradient(to right, #2B894F, #00E558)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
              }}
            >
              It's here.
            </span>
          </h1>
          <p
            className="max-w-5xl mx-auto mb-3 sm:mb-4 lg:mb-6 xl:mb-8"
            style={{ fontSize: "24px", fontWeight: 500, lineHeight: 1.3, color: "#181818" }}
          >
            The GCC's go-to for print, merch, and corporate gifting platform.
          </p>
          
          <div className="flex flex-wrap gap-3 justify-center">
            <a
              href="https://humd.ae"
              className="inline-flex items-center px-6 py-2.5 lg:px-7 lg:py-3 rounded-full font-semibold text-white transition-opacity hover:opacity-90"
              style={{ background: "linear-gradient(to right, #2F9E5C, #0CCC55)" }}
              target="_blank"
              rel="noopener noreferrer"
            >
              Start Ordering
            </a>
            <a
              href="https://enterprise.humd.ae"
              className="inline-flex items-center px-6 py-2.5 lg:px-7 lg:py-3 rounded-full font-semibold bg-white border border-gray-300 text-gray-800 hover:bg-gray-50 transition-colors"
              target="_blank"
              rel="noopener noreferrer"
            >
              Explore Enterprise
            </a>
          </div>
        </div>

        {/* Image Layout */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 pb-6 sm:pb-8 overflow-hidden">
          <div
            className="flex items-center gap-2"
            style={{ height: "clamp(200px, 30vw, 340px)" }}
          >
            {/* Far Left — humdco1 — hidden on small screens */}
            <div
              className="hidden lg:block flex-shrink-0 rounded-3xl overflow-hidden"
              style={{ width: "15%", height: "75%" }}
            >
              <img src="/humdco1.webp" alt="" className="w-full h-full object-cover" />
            </div>

            {/* Center-Left Stack — humdco2 + humdco3 — hidden on small screens */}
            <div
              className="hidden lg:flex flex-shrink-0 flex-col gap-1"
              style={{ width: "16%", height: "90%" }}
            >
              <div className="flex-1 rounded-2xl overflow-hidden">
                <img src="/humdco2.webp" alt="" className="w-full h-full object-cover" />
              </div>
              <div className="flex-1 rounded-2xl overflow-hidden">
                <img src="/humdco3.webp" alt="" className="w-full h-full object-cover" />
              </div>
            </div>

            {/* Main Center — humdco4 — always visible */}
            <div className="flex-1 rounded-2xl overflow-hidden" style={{ height: "100%" }}>
              <img
                src="/humdco4.webp"
                alt="Order management dashboard"
                className="w-full h-full object-cover"
                loading="eager"
                fetchpriority="high"
              />
            </div>

            {/* Center-Right Stack — humdco5 + humdco6 — hidden on small screens */}
            <div
              className="hidden lg:flex flex-shrink-0 flex-col gap-1"
              style={{ width: "13%", height: "90%" }}
            >
              <div className="flex-1 rounded-2xl overflow-hidden">
                <img src="/humdco5.webp" alt="" className="w-full h-full object-cover" />
              </div>
              <div className="flex-1 rounded-2xl overflow-hidden">
                <img src="/humdco6.webp" alt="" className="w-full h-full object-cover" />
              </div>
            </div>

            {/* Far Right — humdco7 — hidden on small screens */}
            <div
              className="hidden lg:block flex-shrink-0 rounded-3xl overflow-hidden"
              style={{ width: "13%", height: "80%" }}
            >
              <img src="/humdco7.webp" alt="" className="w-full h-full object-cover" />
            </div>
          </div>
        </div>
      </div>

      {/* Lower Stats Section */}
      <div className="bg-white">
        <div className="px-4 sm:px-6 max-w-7xl mx-auto w-full pt-4 sm:pt-6 lg:pt-8 pb-0 flex flex-row items-center justify-around gap-2 sm:gap-6 text-center">
        
          <div>
            <p className="text-lg sm:text-2xl lg:text-4xl xl:text-[40px] font-semibold" style={{ color: "#2F9E5C" }}>1000+</p>
            <p className="mt-2" style={{ color: "#111827", fontSize: "16px", fontWeight: 400 }}>Companies Served</p>
          </div>
          <div>
            <p className="text-lg sm:text-2xl lg:text-4xl xl:text-[40px] font-semibold" style={{ color: "#2F9E5C" }}>2.5M+</p>
            <p className="mt-2" style={{ color: "#111827", fontSize: "16px", fontWeight: 400 }}>Products Delivered</p>
          </div>
          <div>
            <p className="text-lg sm:text-2xl lg:text-4xl xl:text-[40px] font-semibold" style={{ color: "#2F9E5C" }}>5+</p>
            <p className="mt-2" style={{ color: "#111827", fontSize: "16px", fontWeight: 400 }}>Countries Delivered To</p>
          </div>
        </div>
       
      </div>
       <div className=" pt-4 sm:pt-6 lg:pt-8">
          <div className="border-t-2 border-gray-300" />
        </div>
    </div>
  );
};

export default NewHeroSection;
